export var getDocumentUsers = function (input) {
    return {
        users: [
            {
                id: 1,
                email: 'john.smith@company.com',
                name: 'John Smith',
                avatar: 'https://i.pravatar.cc/150?img=1',
                isAuthor: true
            },
            {
                id: 2,
                email: 'emma.wilson@company.com',
                name: 'Emma Wilson',
                avatar: 'https://i.pravatar.cc/150?img=2',
                isAuthor: false
            },
            {
                id: 3,
                email: 'michael.brown@company.com',
                name: 'Michael Brown',
                avatar: 'https://i.pravatar.cc/150?img=3',
                isAuthor: false
            }
        ]
    };
};
